import React, { FunctionComponent } from 'react'

interface Props {
  className?: string
}
export const Check: FunctionComponent<Props> = ({ className = '' }) => (
  <svg
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='20'
    viewBox='0 0 28 20'
    stroke='black'
    strokeWidth='3'
    strokeMiterlimit='4'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M2 9.61905L10.0667 18L25.4667 2' fill='none' />
  </svg>
)
